/*
 * Copyright (c) Dito Technologies
 */

import React from "react";
import {createFragmentContainer} from "react-relay";
import {graphql} from "babel-plugin-relay/macro";
import {StaffSelectPageMask_barFinderBar$data} from "./__generated__/StaffSelectPageMask_barFinderBar.graphql"
import styles from "./StaffSelectPageMask.module.scss"
import classnames from "classnames";
import {State} from "ui/feature/root/FormReducer";

const colors = [
    styles.div1,
    styles.div2,
    styles.div3,
    styles.div4,
    styles.div5,
    styles.div6,
    styles.div7,
    styles.div8,
    styles.div9
]


interface Props {
    idx: number;
    state: State;
    barFinderBar: StaffSelectPageMask_barFinderBar$data
}

const StaffSelectPageMask: React.FC<Props> = ({barFinderBar, idx, state}) => {
    const selected = state.selectedBar === barFinderBar.bar_id;
    const style = {
        WebkitMaskBoxImage: `url(${barFinderBar.mask_download_url})`,
    };
    const colorClass = colors[idx % colors.length];
    const isDeleted = React.useMemo(() => {
        for (const deletedBar of state.deletedBars) {
            if (deletedBar === barFinderBar.bar_id) {
                return true
            }
        }
        return false;
    }, [barFinderBar.bar_id, state.deletedBars]);
    if (isDeleted) {
        return null;
    }
    return (
        <div style={style} className={classnames(styles.div, colorClass, {
            [styles.divSelected]: selected,
            [styles.divNotSelected]: !selected
        })}/>
    );
}

export default createFragmentContainer(StaffSelectPageMask, {
    barFinderBar: graphql`
    fragment StaffSelectPageMask_barFinderBar on MusicParseStepDataBarFinderBar {
        bar_id: mask_storage_name
        confidence
        mask_download_url
    }
    `
});
